var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2D38AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3511 10.79C26.6391 10.7902 29.3042 13.4561 29.3042 16.7441C29.3041 20.0322 26.6391 22.6981 23.3511 22.6982C20.0629 22.6982 17.397 20.0323 17.397 16.7441C17.397 13.456 20.0629 10.79 23.3511 10.79ZM23.231 12.5537C23.2297 12.5833 23.138 14.7371 22.2231 15.6523C21.3017 16.5738 19.1235 16.6611 19.1235 16.6611C19.1235 16.6611 21.3017 16.7475 22.2231 17.6689C23.1377 18.5839 23.2297 20.7367 23.231 20.7676C23.2322 20.7368 23.3242 18.5839 24.2388 17.6689C25.1602 16.7475 27.3384 16.6611 27.3384 16.6611C27.3384 16.6611 25.1602 16.5738 24.2388 15.6523C23.3239 14.7371 23.2322 12.5832 23.231 12.5537Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5673 11.1387C18.8769 11.1387 19.1819 11.1589 19.4809 11.1981C17.7343 12.4218 16.5924 14.4495 16.5924 16.7439C16.5924 20.3555 19.4218 23.3062 22.9849 23.5005C22.9659 23.5161 22.9468 23.5318 22.9276 23.5472C22.6932 23.7354 22.5687 24.034 22.6271 24.3289L23.5292 28.8822C23.6217 29.3491 23.2644 29.7841 22.7885 29.7841H16.6795C16.2625 29.7841 15.9244 29.446 15.9244 29.029V27.1702C15.9244 26.7532 15.5863 26.4151 15.1693 26.4151H12.5264C12.1094 26.4151 11.7713 26.077 11.7713 25.66V23.1886C11.7713 22.7716 11.4332 22.4335 11.0162 22.4335H10.901C10.3197 22.4335 9.95643 21.8042 10.2471 21.3008L11.5162 19.1025C11.5967 18.9631 11.6293 18.8016 11.6171 18.6411C11.6038 18.4655 11.597 18.288 11.597 18.1089C11.597 14.2594 14.7177 11.1387 18.5673 11.1387Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1725 24.1032C30.3073 24.2381 30.526 24.2381 30.6609 24.1032C30.7957 23.9684 30.7957 23.7497 30.6609 23.6149L30.1725 24.1032ZM27.3672 20.8096L27.123 21.0538L30.1725 24.1032L30.4167 23.8591L30.6609 23.6149L27.6114 20.5654L27.3672 20.8096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL1);
export default __webpack_public_path__ + "static/media/l1.cb8e1d304ce1d4d8fe87e932c708a62a.svg";
export { ForwardRef as ReactComponent };